/**
 * A serial execution queue based on Promises.
 *
 * @returns {Queue}
 */
export default function createQueue() {
  const queue = [];

  queue.head = Promise.resolve();
  queue.push = (fn) => {
    Array.prototype.push.call(queue, fn);
    queue.head = queue.head.then(async () => {
      // Verify whether or not the function was prematurely removed from the queue.
      if (!queue.includes(fn)) return;

      try {
        await fn();
      } catch (e) {
        // blahhh
      }

      queue.shift();
    });

    return queue.head;
  };

  return queue;
}
